import React, { useState, useEffect } from "react"
import FormGroup from "react-bootstrap/lib/FormGroup"
import InputGroup from "react-bootstrap/lib/InputGroup"
import FormControl from "react-bootstrap/lib/FormControl"
import Button from "react-bootstrap/lib/Button"

import style from "./index.module.sass"
// ----------------------------------------------------------------------------

const placeholder = I18n.t("pages.locations.venues.search.placeholder")

function VenueChooserSearchBar(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    onChange = () => {},
    defaultText = "",
    onSearch = () => {},
    isLoading = false,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [currentText, setCurrentText] = useState(defaultText)

  // -------------------------------------
  // Effects
  // -------------------------------------

  useEffect(() => {
    onChange(currentText)
  }, [currentText])

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleEnterPressed(event) {
    if (event.keyCode === 13) {
      onSearch(currentText)
      event.preventDefault()
    }
  }

  function handleSearch() {
    onSearch(currentText)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div>
      <p className={style.searchTitle}>
        {I18n.t("pages.locations.venues.search.title")}
      </p>
      <form className={style.inputForm} autoComplete="off">
        <FormGroup style={{ marginBottom: 0 }}>
          <InputGroup className="">
            <FormControl
              type="text"
              className={style.formControl}
              style={{ border: "none" }}
              value={currentText}
              placeholder={placeholder}
              onKeyDown={(e) => {
                handleEnterPressed(e)
              }}
              onChange={(e) => setCurrentText(e.target.value)}
            />
            <InputGroup.Button>
              <Button
                bsStyle="default"
                className={style.search}
                style={{ border: "none" }}
                onClick={handleSearch}
                disabled={isLoading}
              >
                <i className="fal fa-search search-icon" />
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
      </form>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default VenueChooserSearchBar
